import { secondAxios } from "../../../../../../../api/axios";

export const handleSelectFile = async ({ e, dbData, setData }) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();

    // Read file content
    reader.onload = async (e) => {
      try {
        const parsedData = JSON.parse(e.target.result);
        console.log("Parsed JSON Data: ", parsedData);
        console.log("Project Data: ", dbData);

        const newDrawings = [];

        parsedData?.forEach((d) => {
          const existedDrawing = dbData?.find(
            (item) =>
              item.softwareId === d.softwareId && item.revision === d.revision
          );

          if (!existedDrawing) {
            newDrawings.push(d);
          }
        });

        let selectedDrawings = [];
        let uploadedDrawings = [];

        if (newDrawings.length) {
          const res = await secondAxios.post("/drawing", newDrawings);
          if (res?.data) {
            selectedDrawings = res.data;
            uploadedDrawings = res.data;
          }
        }

        console.log("Uploaded Drawings: ", uploadedDrawings);

        selectedDrawings = parsedData.map((d) => {
          const existedDrawing = dbData?.find(
            (item) =>
              item.softwareId === d.softwareId && item.revision === d.revision
          );

          if (existedDrawing) {
            return {
              id: existedDrawing.id,
              ...d,
              selectedSource: "sharepoint",
              title: d.dwgTitle || d.title,
            };
          } else {
            return uploadedDrawings.find(
              (ud) =>
                ud.softwareId === d.softwareId && ud.revision === d.revision
            );
          }
        });

        console.log("selected Drawing Data: ", selectedDrawings);
        setData(
          selectedDrawings.map((d) => {
            return {
              ...d,
              selectedSource: "sharepoint",
              title: d.dwgTitle || d.title,
            };
          })
        );
      } catch (error) {
        console.error("Error parsing JSON file:", error);
      }
    };

    reader.readAsText(file); // Read file as text
  }
};
